import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Resource } from '@klickdata/core/resource';
import { ResourceItem, ResourceItemService } from '@klickdata/core/resource-item';
import { Utils } from '@klickdata/core/util';
import { BehaviorSubject, Observable, of, shareReplay } from 'rxjs';

@Component({
    selector: 'app-resource-builder-material-extra',
    templateUrl: './resource-builder-material-extra.component.html',
    styleUrls: ['./resource-builder-material-extra.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceBuilderMaterialExtraComponent implements OnInit, OnChanges {
    @Input() resourceItemSubject: BehaviorSubject<ResourceItem>;
    @Input() resourceItem: ResourceItem;
    public resourceItem$: Observable<ResourceItem>;
    Utils = Utils;
    constructor(protected itemService: ResourceItemService, protected changeRef: ChangeDetectorRef) {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.resourceItemSubject) {
            this.resourceItem$ = this.resourceItemSubject.asObservable().pipe(shareReplay());
        }
        if (changes.resourceItem) {
            this.resourceItem$ = of(this.resourceItem);
        }
    }
}
